export default __webpack_public_path__ + "static/media/infoIcon.fcbd9a77.svg";